// Silifke Sepeti: yatay kayan raflar (ürünler, videolar, SSS, yorumlar) için ortak ok butonu mantığı
function scrollRail(id, dir) {
  var el = document.getElementById(id);
  if (!el) return;
  var amount = el.clientWidth * 0.7;
  el.scrollBy({ left: dir * amount, behavior: 'smooth' });
}
